import "./DropDownsComponent.scss";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikProps} from 'formik';
import React, {useCallback, useEffect} from "react";
import {Grid} from "@mui/material";
import commonService from "../../../shared/services/common.service";
import FormikSelectDropdownComponent
    from "../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import SystemSettingsTableWrapperComponent from "../system-settings-table-wrapper/SystemSettingsTableWrapperComponent";
import InsuranceConfigurationScreenComponent
    from "../insurance-configuration-screen/InsuranceConfigurationScreenComponent";

interface DropDownsComponentProps {

}

const SystemSettingsValidationSchema = Yup.object().shape({
    module: Yup.mixed().required('Type is required'),
    feature: Yup.mixed().required('Feature is required'),
});

interface SystemSettingsFormSchema {
    module: any;
    feature: any;
}

const systemSettingsFormInitialValues: SystemSettingsFormSchema = {
    module: null,
    feature: null,
}

const DropdownsComponent = (props: DropDownsComponentProps) => {

    const [module, setModule] = React.useState<any>("");
    const [feature, setFeature] = React.useState<any>("");
    const [featureTitle, setFeatureTitle] = React.useState<any>("");
    const [moduleFeaturesMappings, setModuleFeaturesMappings] = React.useState<any>([]);
    const [moduleFeatures, setModuleFeatures] = React.useState<any>(undefined);
    const [dropdownKeys, setDropdownKeys] = React.useState<any>([]);
    const [dropdownsDataLoadingFailed, setDropdownsDataLoadingFailed] = React.useState<boolean>(false);
    const [dropdownsDataLoading, setDropdownsDataLoading] = React.useState<boolean>(false);
    const [dropdownsDataLoaded, setDropdownsDataLoaded] = React.useState<boolean>(false);
    const formikRef = React.useRef<FormikProps<any>>(null);
    const [isPaginated, setIsPaginated] = React.useState<boolean>(false);

    const getModulesDropdownData = useCallback(() => {
        const payload = {};
        setDropdownsDataLoading(true);
        setDropdownsDataLoaded(false);
        setDropdownsDataLoadingFailed(false);
        commonService._systemSettings.getModulesDropdownList(payload)
            .then((res: any) => {
                setDropdownsDataLoaded(true);
                setDropdownsDataLoading(false);
                setDropdownsDataLoadingFailed(false);
                setDropdownKeys(Object.keys(res.data));
                setModuleFeaturesMappings(Object.entries(res.data).map(([key, value]) => ({key, value})));
            })
            .catch((err: any) => {
                setDropdownsDataLoaded(false)
                setDropdownsDataLoadingFailed(true)
                setDropdownsDataLoading(false)
            })
    }, [])

    useEffect(() => {
        getModulesDropdownData();
    }, [getModulesDropdownData])

    const handleModuleChange = useCallback((value: any, setFieldValue: any) => {
        setFieldValue('feature', null);
        setModuleFeatures(moduleFeaturesMappings.find((item: any) => item.key === value)?.value);
        setModule(value);
        setFeature('');
    }, [moduleFeaturesMappings])

    const handleFeatureChange = useCallback((value: any) => {
        setFeature(value.code);
        setFeatureTitle(value.title);
        setIsPaginated(value.isPaginated ? value.isPaginated : false);
    }, [])


    return (
        <div className={'dropdowns-component'}>
            <Formik
                initialValues={systemSettingsFormInitialValues}
                onSubmit={() => {

                }}
                innerRef={formikRef}
                validationSchema={SystemSettingsValidationSchema}
            >
                {({isSubmitting, values, isValid, touched, setFieldValue, validateForm, errors}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                    }, [validateForm, values]);
                    return (
                        <Form noValidate={true}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Field name={'module'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikSelectDropdownComponent
                                                    label={'Select Type'}
                                                    placeholder={'Select Type'}
                                                    required={true}
                                                    formikField={field}
                                                    isDataLoading={dropdownsDataLoading}
                                                    isDataLoaded={dropdownsDataLoaded}
                                                    // isDataLoadingFailed={dropdownsDataLoadingFailed}
                                                    options={dropdownKeys}
                                                    onUpdate={(value: any) => handleModuleChange(value, setFieldValue)}
                                                    getOptionLabel={(option: any) => commonService.capitalizeFirstLetter(option)}
                                                />
                                            )
                                        }
                                    </Field>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field name={'feature'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikSelectDropdownComponent
                                                    label={'Select Feature'}
                                                    placeholder={'Select Feature'}
                                                    required={true}
                                                    formikField={field}
                                                    isDataLoading={dropdownsDataLoading}
                                                    isDataLoaded={dropdownsDataLoaded}
                                                    disabled={!module}
                                                    isDataLoadingFailed={dropdownsDataLoadingFailed}
                                                    onUpdate={(value: any) => handleFeatureChange(value)}
                                                    options={moduleFeatures}
                                                    getOptionLabel={(option: any) => option.title}
                                                />
                                            )
                                        }
                                    </Field>
                                </Grid>
                            </Grid>
                        </Form>
                    )
                }}
            </Formik>
            {
                (module === 'patient' && feature === 'insurers') ?
                    <InsuranceConfigurationScreenComponent/> :
                    <SystemSettingsTableWrapperComponent module={module} feature={feature} isPaginated={isPaginated}
                                                         featureTitle={featureTitle}/>
            }
        </div>
    );

};

export default DropdownsComponent;
